import { nonNullable } from '~/@lib/utils/type.utils'
import type { ProjectSchema } from '~/@pages_investing/projects/_project_types/project.types'
import { Text } from '~/@mid_ui/typography/Text'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { useCountryName } from '~/@mid_settings/countries/useCountryName'
import { DetailHeading } from '../detail-heading/DetailHeading'
import { DetailItem } from '../detail-item/DetailItem'
import { projectDetailTooltipByType } from '../detail-tooltips/detailTooltips'

type Props = { project: ProjectSchema }

function DebtorInfo({ project }: Props) {
  const developer = project.developer.profile
  const isDesktop = useIsDesktop()

  const { iisScore, latePaymentsCount } = developer.developerInfo ?? {}

  const items = [
    nonNullable(iisScore)
      ? {
          heading: <DetailHeading title="Skóre IIS:" />,
          value: <Text>{iisScore}</Text>,
        }
      : null,
    nonNullable(latePaymentsCount)
      ? {
          heading: (
            <DetailHeading
              title="Omeškané platby:"
              tooltip={projectDetailTooltipByType.latePayments}
            />
          ),
          value: <Text>{latePaymentsCount}</Text>,
        }
      : null,
    {
      heading: <DetailHeading title="Právna forma:" />,
      value: <Text>{developer.company?.legalForm || 'N/A'}</Text>,
    },
    {
      heading: (
        <DetailHeading
          title="Názov:"
          tooltip={projectDetailTooltipByType.companyName}
        />
      ),
      value: <Text>{developer.company?.name || 'N/A'}</Text>,
    },
    {
      heading: <DetailHeading title="IČO:" />,
      value: <Text>{developer.company?.id || 'N/A'}</Text>,
    },
    {
      heading: <DetailHeading title="Lokalita:" />,
      value: <CountryName state={developer.company?.state ?? 'SK'} />,
    },
  ]

  return (
    <DetailItem
      borderBottom={isDesktop ? 'none' : undefined}
      title="Info o dlžníkovi"
      rows={items.filter(nonNullable)}
      sectionId="debtorInfo"
    />
  )
}

function CountryName({ state }: { state: string }) {
  const { getCountryName } = useCountryName()
  return <Text>{getCountryName(state) || 'Slovensko'}</Text>
}

export { DebtorInfo }
